export { FAQ } from './faq';
